import React from 'react';
import '../../style/scss/selectionPanel.scss';
import { MdCheckBoxOutlineBlank, MdOutlineCheckBox } from "react-icons/md";

export default function SkillLevelListItem(props) {
   const levels = [
      { value: 1, label: 'Beginner' },
      { value: 2, label: 'Junior' },
      { value: 3, label: 'Intermediate' },
      { value: 4, label: 'Senior' },
      { value: 5, label: 'Guru' },
   ];
   const useStyles = makeStyles((theme) => ({
      root: {
         width: 300,
      },
      margin: {
         height: theme.spacing(3),
      },
   }));
   const classes = useStyles();
   const setLevel = (e, value) => {
      if (props.onChange)
         props.onChange(value, props.skill.SkillID, e);
   }
   const toggleRequired = e => {
      if (props.onToggleRequired)
         props.onToggleRequired(props.skill.SkillID, e);
   }
   return (
      <span className="skillLink " onClick={props.toggleValue}>
         <div className="SkillLevel selectionPanel" id={props.skill.SkillID}  >
            <span className='title'>{props.skill.SkillName}</span>
            <span className={'byline ' + classes.root}>
               <Slider
                  defaultValue={props.skill.Level}
                  step={1}
                  aria-labelledby="discrete-slider-custom"
                  marks={levels}
                  min={1}
                  max={5}
                  onChange={setLevel}
               />
            </span>
            <span className='rightText'>
               <div className='icon'>
                  <div onClick={toggleRequired}>
                     <MdCheckBoxOutlineBlank size={1} color="#0075FF" className={props.skill.Required ? 'hidden' : ''} />
                     <MdOutlineCheckBox size={1} color="#0075FF" className={props.skill.Required ? '' : 'hidden'} />
                  </div>
                  <span className='label'>Required</span>
               </div>
            </span>
         </div>
      </span>
   );
}
